<template>
  <div class="container">
    <div class="info">
      <!-- 标题 -->
      <div class="title">{{ $t('share').Commissionrecord }}</div>
      <!-- 列表 -->
      <div class="listInfo">
        <div class="item" v-for="(dItem, dIndex) in oList" :key="`com${dIndex}`">
          <div class="name">{{ $t('share').Commissioncommission }} <span class="amount red" v-if="dItem.amount < 0">-${{
            -dItem.amount.toFixed(2).replace(/\.?0+$/, '') }}</span>
            <span class="amount green" v-else>+${{ dItem.amount.toFixed(2).replace(/\.?0+$/, '') }}</span>
          </div>
          <div class="time">{{ dItem.operTime | getLocalTime }} <span>${{ dItem.after.toFixed(2).replace(/\.?0+$/, '')
              }}</span></div>
        </div>
        <!-- 分页 -->
        <div class="pagefoot">
          <el-pagination :current-page="parms.pageNum" :page-size="parms.pageSize" layout="prev, pager, next"
            hide-on-single-page :total="total" @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userApi from '@/api/user'
export default {
  components: {
  },
  data() {
    return {
      parms: {
        pageNum: 1,
        pageSize: 10,
        type: '1'
      },
      oList: [],
      total: 0,
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    this.getCommissionChangeLog()
  },
  methods: {
    // 切换分页
    handleCurrentChange(val) {
      this.parms.pageNum = val
      this.getCommissionChangeLog()
    },
    // 获取佣金记录
    async getCommissionChangeLog() {
      const res = await userApi.getCommissionChangeLog(this.parms)
      this.oList = res.rows
      this.total = res.total
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  padding-top: 110px;
  padding-bottom: 80px;
  width: 100%;
  background: var(--background_color);

  .info {
    margin: 0 auto;
    max-width: 780px;

    .title {
      font-size: 48px;
      font-weight: bold;
      color: var(--text_color);
    }

    .listInfo {
      margin-top: 20px;
      padding-bottom: 80px;

      .item {
        padding: 20px;
        background: var(--background_color);
        color: var(--text_color);
        font-size: 15px;
        border-bottom: 1px solid rgba(151, 177, 199, 0.3);

        .name {
          display: flex;
          justify-content: space-between;
          font-size: 18px;
          color: var(--text_color);
        }

        .time {
          margin-top: 20px;
          font-size: 14px;
          color: var(--ntext_color);
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .order {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 10px;
          font-size: 14px;
          color: var(--ntext_color);

          span {
            color: var(--primary_color);
          }
        }
      }

      .item:hover {
        background: var(--info_color);
      }

      .pagefoot {
        margin-top: 20px;
        text-align: right;
      }
    }
  }
}

// 分页
::v-deep .el-pagination button {
  color: var(--text_color);
  background-color: var(--background_color);
}

::v-deep .el-pager li {
  background: var(--background_color);
  color: var(--text_color);
}

::v-deep .el-pager li.active {
  color: var(--background_color);
  background: var(--text_color);
  border-radius: 15px;
}
</style>
